import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";

export const Route = createFileRoute("/admin")({
  head: () => buildRouteHead("/admin", { noIndex: true }),
  component: Admin,
});

